export default __webpack_public_path__ + "static/media/search.99a39d29.svg";